import MainLayout from "../Pages/SideMenu";

const ProtectedRouteAuth = ({ isLoggedIn }) => {
  console.log("isLoggedin33", isLoggedIn);
  //   const isLoggedIn = true;
  return isLoggedIn ? <MainLayout /> : <></>;
};

export default ProtectedRouteAuth;
